import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Loading from '../../components/loading';
import './home.scss';
import Header from '../Header';
import Nav from '../Nav';
import Tabs from '../Tabs';
import TableRankingTitle from '../TableRankingTitle';
import TableRankingIndividual from '../TableRankingIndividual';
import TableRankingTeam from '../TableRankingTeam';
import TableCalendarTeam from '../TableCalendarTeam';
import TableCalendarIndividual from '../TableCalendarIndividual';
import FilterModal from '../FilterModal';
import config from '../../config';
import handleResponse from '../../utils/handleResponse';
import banner from '../../assets/images/new/bannerCDR 02.png';
import bannerMobile from '../../assets/images/new/bannerCDR01.png';

const SUM_OF_TIMES = 'sum_of_times';
const THIRD_TO_ARRIVE = 'third_to_arrive';

const CALENDAR_INDIVIDUAL = 0;
const CALENDAR_TEAM = 1;
const RANKING_INDIVIDUAL = 2;
const RANKING_TEAM = 3;
const RANKING_GENERAL = 4;
const RANKING_SPRINT = 5;

const TAB_CLOCK = 0;
const TAB_INDIVIDUAL = 2;
const TAB_TEAM = 3;
const TAB_GENERAL = 1;

const Home = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const queryDay = parseInt(
    queryParams.get('day') || queryParams.get('scheduleDay') || '',
    10
  );
  const forcedRaceDay = queryDay === 1 || queryDay === 2 ? queryDay : null;
  const [showLoading, setShowLoading] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showSecondLoading, setShowSecondLoading] = useState(false);
  const [isIndividual, setIsIndividual] = useState(false);
  const [individualSegment, setIndividualSegment] = useState(false);
  const [showIndividualFavoriteLoading, setShowIndividualFavoriteLoading] =
    useState(false);
  const [showTeamFavoriteLoading, setShowTeamFavoriteLoading] = useState(false);
  const [raceEvents, setRaceEvents] = useState([]);
  const [individualFavorites, setIndividualFavorites] = useState([]);
  const [teamFavorites, setTeamFavorites] = useState([]);
  const [raceEvent, setRaceEvent] = useState(null);
  const [raceDay, setRaceDay] = useState(null);
  const [selectedCityFilter, setSelectedCityFilter] = useState(null);
  const [selectedSegmentFilter, setSelectedSegmentFilter] = useState(null);
  const [selectedGenderFilter, setSelectedGenderFilter] = useState(null);
  const [selectedGenderCategoryFilter, setSelectedGenderCategoryFilter] =
    useState(null);
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState(null);
  const [
    selectedIndividualCategoryFilter,
    setSelectedIndividualCategoryFilter,
  ] = useState(null);
  const [selectedAgeCategoryFilter, setSelectedAgeCategoryFilter] =
    useState(null);
  const [selectedSportFilter, setSelectedSportFilter] = useState(null);
  const [changeIndividual, setChangeIndividual] = useState(null);
  const [changeTeam, setChangeTeam] = useState(null);
  const [searchText, setSearchText] = useState('');
  const noticeConfig = {
    showScheduleNotice: false,
    showGeneralNotice: false,
    showCriNotice: false,
    showCreNotice: false,
    ...(raceEvent?.noticeConfig || {}),
  };
  const isCronoRigo = raceEvent?.eventType === 'crono-rigo';
  const tabs = [
    isCronoRigo
      ? raceDay === 2
        ? 'HORARIOS CRE'
        : 'HORARIOS CRI'
      : 'HORARIOS',
    'GENERAL',
    'CRI',
    'CRE',
  ];
  const getLocalUser = () => {
    try {
      return JSON.parse(localStorage.getItem('userData') || 'null');
    } catch (e) {
      return null;
    }
  };
  const favoritesEnabled = !!(
    getLocalUser()?.userToken && getLocalUser()?.user?.id
  );
  const resetFilters = () => {
    setSelectedCityFilter(null);
    setSelectedSegmentFilter(null);
    setSelectedGenderFilter(null);
    setSelectedGenderCategoryFilter(null);
    setSelectedAgeCategoryFilter(null);
    setSelectedCategoryFilter(null);
    setSelectedIndividualCategoryFilter(null);
    setSelectedSportFilter(null);
    if (isIndividual) {
      setChangeIndividual(new Date().getTime());
      setChangeTeam(null);
    } else {
      setChangeTeam(new Date().getTime());
      setChangeIndividual(null);
    }
  };

  useEffect(() => {
    getEvents();
  }, []);

  useEffect(() => {
    if (raceEvents.length > 0) {
      setRaceEvent(raceEvents[0]);
    }
  }, [raceEvents]);

  useEffect(() => {
    if (raceEvent) {
      getIndividualFavorites();
      getTeamFavorites();

      // setRaceDay(raceEvent.raceDays[1]);
      setRaceDay(forcedRaceDay || raceEvent.currentDay);
      // setRaceDay(2);
      // const now = moment();
      // let newRaceDay;
      // raceEvent.raceDays.forEach((filterRaceDay) => {
      //   const start = moment(filterRaceDay.startDate);
      //   const end = moment(filterRaceDay.endDate);
      //   if (now > start && now < end) {
      //     newRaceDay = filterRaceDay;
      //   }
      // });
      // if (!newRaceDay) {
      //   const start = moment(raceEvent.startDate);
      //   const end = moment(raceEvent.endDate);
      //   if (now < start) {
      //     newRaceDay = raceEvent.raceDays[0];
      //   }
      //   if (now > end) {
      //     newRaceDay = raceEvent.raceDays[raceEvent.raceDays.length - 1];
      //   }
      // }
      // newRaceDay = raceEvent.raceDays[1];
      // setRaceDay(newRaceDay);
    }
  }, [raceEvent, forcedRaceDay]);

  const getEvents = async () => {
    setShowLoading(true);
    const requestOptions = {
      method: 'GET',
    };
    const response = await fetch(
      `${config.tncApiUrl}/sport-events/${config.eventId}`,
      requestOptions
    );
    setShowLoading(false);
    try {
      const events = await handleResponse(response);
      console.log('events', events);
      setRaceEvent(events.data);
    } catch (error) {
      console.log('error', error);
    }
  };

  const getIndividualFavorites = async () => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) {
      setIndividualFavorites([]);
      return;
    }
    // setShowIndividualFavoriteLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
    };
    const requestOptions = {
      method: 'GET',
      headers,
    };
    let url;

    url = new URL(
      `${config.tncApiUrl}/user-event/favorites?orderByTotalDistance=true`
    );

    url.searchParams.append('userId', athlete.user.id);
    url.searchParams.append('sportEventId', config.eventId);

    const response = await fetch(url, requestOptions);
    // setShowIndividualFavoriteLoading(false);
    try {
      const newIndividualFavorites = await handleResponse(response);

      setIndividualFavorites(newIndividualFavorites.data.favorites);
    } catch (error) {
      console.log('error', error);
    }
  };

  const saveFavorite = async (favorite) => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) return;
    setShowLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
      'Content-Type': 'application/json',
    };
    const requestOptions = {
      method: 'POST',
      headers,
      body: JSON.stringify({
        userId: athlete.user.id,
        favoriteId: favorite,
        sportEventId: config.eventId,
      }),
    };
    const url = new URL(`${config.tncApiUrl}/user-event/favorite`);
    await fetch(url, requestOptions);
    setShowLoading(false);
    try {
      getIndividualFavorites();
    } catch (error) {
      console.log('error', error);
    }
  };

  const deleteFavorite = async (favorite) => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) return;
    setShowLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
      'Content-Type': 'application/json',
    };
    const requestOptions = {
      method: 'DELETE',
      headers,
      body: JSON.stringify({
        userId: athlete.user.id,
        favoriteId: favorite,
        sportEventId: config.eventId,
      }),
    };
    const url = new URL(`${config.tncApiUrl}/user-event/favorite`);

    await fetch(url, requestOptions);
    setShowLoading(false);
    try {
      getIndividualFavorites();
    } catch (error) {
      console.log('error', error);
    }
  };

  const getTeamFavorites = async () => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) {
      setTeamFavorites([]);
      return;
    }
    // setShowIndividualFavoriteLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
    };
    const requestOptions = {
      method: 'GET',
      headers,
    };
    let url;

    url = new URL(
      `${config.tncApiUrl}/user-event-team/favorites?orderByTotalDistance=true`
    );

    url.searchParams.append('userId', athlete.user.id);
    url.searchParams.append('sportEventId', config.eventId);

    const response = await fetch(url, requestOptions);
    // setShowIndividualFavoriteLoading(false);
    try {
      const newIndividualFavorites = await handleResponse(response);

      setTeamFavorites(newIndividualFavorites.data.favorites);
    } catch (error) {
      console.log('error', error);
    }
  };

  const saveTeamFavorite = async (favorite) => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) return;
    setShowLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
      'Content-Type': 'application/json',
    };
    const requestOptions = {
      method: 'POST',
      headers,
      body: JSON.stringify({
        userId: athlete.user.id,
        teamId: favorite,
        sportEventId: config.eventId,
      }),
    };
    const url = new URL(`${config.tncApiUrl}/user-event-team/favorite`);
    await fetch(url, requestOptions);
    setShowLoading(false);
    try {
      getTeamFavorites();
    } catch (error) {
      console.log('error', error);
    }
  };

  const deleteTeamFavorite = async (favorite) => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) return;
    setShowLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
      'Content-Type': 'application/json',
    };
    const requestOptions = {
      method: 'DELETE',
      headers,
      body: JSON.stringify({
        userId: athlete.user.id,
        teamId: favorite,
        sportEventId: config.eventId,
      }),
    };
    const url = new URL(`${config.tncApiUrl}/user-event-team/favorite`);

    await fetch(url, requestOptions);
    setShowLoading(false);
    try {
      getTeamFavorites();
    } catch (error) {
      console.log('error', error);
    }
  };

  const [rakingType, setRakingType] = useState(0);
  const onTabChange = (tab) => {
    console.log('tab', tab);
    let newRakingType = 0;
    switch (tab) {
      case TAB_CLOCK: {
        setIndividualSegment(null);
        if (raceDay === 1) {
          setIsIndividual(true);
          newRakingType = CALENDAR_INDIVIDUAL;
        } else {
          setIsIndividual(false);
          newRakingType = CALENDAR_TEAM;
        }
        break;
      }
      case TAB_INDIVIDUAL: {
        setIndividualSegment(null);
        setIsIndividual(true);
        newRakingType = RANKING_INDIVIDUAL;
        break;
      }
      case TAB_TEAM: {
        setIndividualSegment(null);
        setIsIndividual(false);
        newRakingType = RANKING_TEAM;
        break;
      }
      case TAB_GENERAL: {
        setIndividualSegment(null);
        setIsIndividual(false);
        newRakingType = RANKING_GENERAL;
        break;
      }
      default: {
        setIndividualSegment(null);
        if (raceDay === 1) {
          setIsIndividual(true);
          newRakingType = CALENDAR_INDIVIDUAL;
        } else {
          setIsIndividual(false);
          newRakingType = CALENDAR_TEAM;
        }
        break;
      }
    }
    setRakingType(newRakingType);
  };

  useEffect(() => {
    if (raceDay) {
      onTabChange(0);
    }
  }, [raceDay]);

  const renderTable = () => {
    switch (rakingType) {
      case CALENDAR_INDIVIDUAL:
        return (
          <TableCalendarIndividual
            raceDay={raceDay}
            raceEvent={raceEvent}
            setShowLoading={setShowLoading}
            setShowSecondLoading={setShowSecondLoading}
            individualFavorites={individualFavorites}
            saveFavorite={saveFavorite}
            deleteFavorite={deleteFavorite}
            selectedGenderFilter={selectedGenderFilter}
            selectedIndividualCategoryFilter={selectedIndividualCategoryFilter}
            changeIndividual={changeIndividual}
            favoritesEnabled={favoritesEnabled}
            searchText={searchText}
          />
        );
      case CALENDAR_TEAM:
        return (
          <TableCalendarTeam
            raceDay={raceDay}
            raceEvent={raceEvent}
            setShowLoading={setShowLoading}
            setShowSecondLoading={setShowSecondLoading}
            teamFavorites={teamFavorites}
            saveTeamFavorite={saveTeamFavorite}
            deleteTeamFavorite={deleteTeamFavorite}
            selectedCityFilter={selectedCityFilter}
            selectedGenderCategoryFilter={selectedGenderCategoryFilter}
            selectedCategoryFilter={selectedCategoryFilter}
            changeTeam={changeTeam}
            favoritesEnabled={favoritesEnabled}
            searchText={searchText}
          />
        );
      case RANKING_INDIVIDUAL:
        return (
          <TableRankingIndividual
            raceDay={raceDay}
            raceEvent={raceEvent}
            setShowLoading={setShowLoading}
            setShowSecondLoading={setShowSecondLoading}
            individualFavorites={individualFavorites}
            saveFavorite={saveFavorite}
            deleteFavorite={deleteFavorite}
            selectedGenderFilter={selectedGenderFilter}
            selectedIndividualCategoryFilter={selectedIndividualCategoryFilter}
            changeIndividual={changeIndividual}
            favoritesEnabled={favoritesEnabled}
            searchText={searchText}
          />
        );
      case RANKING_TEAM:
        return (
          <TableRankingTeam
            cre={true}
            raceDay={raceDay}
            raceEvent={raceEvent}
            setShowLoading={setShowLoading}
            setShowSecondLoading={setShowSecondLoading}
            teamFavorites={teamFavorites}
            saveTeamFavorite={saveTeamFavorite}
            deleteTeamFavorite={deleteTeamFavorite}
            selectedCityFilter={selectedCityFilter}
            selectedGenderCategoryFilter={selectedGenderCategoryFilter}
            selectedCategoryFilter={selectedCategoryFilter}
            changeTeam={changeTeam}
            favoritesEnabled={favoritesEnabled}
            searchText={searchText}
          />
        );
      case RANKING_SPRINT:
        return (
          <TableRankingTeam
            sprint={true}
            raceDay={raceDay}
            raceEvent={raceEvent}
            setShowLoading={setShowLoading}
            setShowSecondLoading={setShowSecondLoading}
            teamFavorites={teamFavorites}
            saveTeamFavorite={saveTeamFavorite}
            deleteTeamFavorite={deleteTeamFavorite}
            selectedCityFilter={selectedCityFilter}
            selectedGenderCategoryFilter={selectedGenderCategoryFilter}
            selectedCategoryFilter={selectedCategoryFilter}
            changeTeam={changeTeam}
            favoritesEnabled={favoritesEnabled}
            searchText={searchText}
          />
        );
      case RANKING_GENERAL:
        return (
          <TableRankingTeam
            overlapBadge
            raceDay={raceDay}
            raceEvent={raceEvent}
            setShowLoading={setShowLoading}
            setShowSecondLoading={setShowSecondLoading}
            teamFavorites={teamFavorites}
            saveTeamFavorite={saveTeamFavorite}
            deleteTeamFavorite={deleteTeamFavorite}
            selectedCityFilter={selectedCityFilter}
            selectedGenderCategoryFilter={selectedGenderCategoryFilter}
            selectedCategoryFilter={selectedCategoryFilter}
            changeTeam={changeTeam}
            favoritesEnabled={favoritesEnabled}
            searchText={searchText}
          />
        );
      default:
        <TableCalendarTeam
          raceDay={raceDay}
          raceEvent={raceEvent}
          setShowLoading={setShowLoading}
          setShowSecondLoading={setShowSecondLoading}
          saveTeamFavorite={saveTeamFavorite}
          deleteTeamFavorite={deleteTeamFavorite}
          teamFavorites={teamFavorites}
          selectedCityFilter={selectedCityFilter}
          selectedGenderCategoryFilter={selectedGenderCategoryFilter}
          selectedCategoryFilter={selectedCategoryFilter}
          changeTeam={changeTeam}
        />;
        break;
    }
  };

  const getActiveNoticeMessage = () => {
    if (!isCronoRigo) return '';

    if (
      (rakingType === CALENDAR_INDIVIDUAL || rakingType === CALENDAR_TEAM) &&
      noticeConfig.showScheduleNotice
    ) {
      return 'DEBEN PRESENTARSE 20MIN ANTES EN LA PLATAFORMA';
    }

    if (rakingType === RANKING_GENERAL && noticeConfig.showGeneralNotice) {
      return 'Tiempos no oficiales';
    }

    if (rakingType === RANKING_INDIVIDUAL && noticeConfig.showCriNotice) {
      return 'Tiempos no oficiales';
    }

    if (rakingType === RANKING_TEAM && noticeConfig.showCreNotice) {
      return 'Tiempos no oficiales';
    }

    return '';
  };

  const activeNoticeMessage = getActiveNoticeMessage();

  const goRappi = () => {
    window.open('https://bit.ly/3A6WCbC', '_blank').focus();
  };

  return (
    <div className='home'>
      {(showLoading ||
        showIndividualFavoriteLoading ||
        showTeamFavoriteLoading ||
        showSecondLoading) && <Loading />}
      {showFilterModal && (
        <FilterModal
          setShowLoading={setShowLoading}
          isIndividual={isIndividual}
          isIndividualCalendar={rakingType === CALENDAR_INDIVIDUAL}
          closeModal={() => {
            setShowFilterModal(false);
          }}
          selectedCityFilter={selectedCityFilter}
          selectedSegmentFilter={selectedSegmentFilter}
          selectedGenderFilter={selectedGenderFilter}
          selectedGenderCategoryFilter={selectedGenderCategoryFilter}
          selectedCategoryFilter={selectedCategoryFilter}
          selectedIndividualCategoryFilter={selectedIndividualCategoryFilter}
          selectedAgeCategoryFilter={selectedAgeCategoryFilter}
          selectedSportFilter={selectedSportFilter}
          setSelectedCityFilter={setSelectedCityFilter}
          setSelectedSegmentFilter={setSelectedSegmentFilter}
          setSelectedGenderFilter={setSelectedGenderFilter}
          setSelectedGenderCategoryFilter={setSelectedGenderCategoryFilter}
          setSelectedCategoryFilter={setSelectedCategoryFilter}
          setSelectedIndividualCategoryFilter={
            setSelectedIndividualCategoryFilter
          }
          setSelectedAgeCategoryFilter={setSelectedAgeCategoryFilter}
          setSelectedSportFilter={setSelectedSportFilter}
          setChangeIndividual={setChangeIndividual}
          setChangeTeam={setChangeTeam}
        />
      )}
      <Header
        resetFilters={resetFilters}
        showReset={
          !!selectedCityFilter ||
          !!selectedAgeCategoryFilter ||
          !!selectedGenderFilter ||
          !!selectedSegmentFilter ||
          !!selectedGenderCategoryFilter ||
          !!selectedCategoryFilter ||
          !!selectedIndividualCategoryFilter ||
          !!selectedSportFilter
        }
      />
      <div className='banner hide-mobile'>
        <img src={banner} alt='adds' />
      </div>
      <div className='banner hide-desktop'>
        <img src={bannerMobile} alt='adds' />
      </div>
      <div className='fixed-header'>
        <Nav
          openFilter={() => {
            setShowFilterModal(true);
          }}
          searchText={searchText}
          onSearchChange={setSearchText}
        />
        <Tabs tabs={tabs} onChange={onTabChange} />
        {activeNoticeMessage && (
          <div className='tab-info-banner'>{activeNoticeMessage}</div>
        )}
        <TableRankingTitle rakingType={rakingType} />
      </div>
      {raceEvent && raceDay && renderTable()}
    </div>
  );
};

export default Home;
